import { Injectable, signal } from '@angular/core';

import { Subject } from 'rxjs';

import type { HRAssistantFeature } from './hr-assistant-chat.component';

@Injectable({
  providedIn: 'root',
})
export class HrAssistantChatFeatureService {
  public activeFeature = signal<HRAssistantFeature | null>(null);
  public activeFeatureInputs = signal<Record<string, unknown> | undefined>(undefined);
  public close$ = new Subject<void>();
  public newThread$ = new Subject<void>();
  public features: HRAssistantFeature[] = [];

  public setFeatures(features: HRAssistantFeature[]) {
    this.features = features;
  }

  public setFeature(feature: HRAssistantFeature, inputs?: Record<string, unknown>) {
    this.activeFeature.set(feature);
    this.activeFeatureInputs.set(inputs);
  }

  public setFeatureById(featureId: string, inputs?: Record<string, unknown>) {
    const feature = this.features.find(f => f.id === featureId) || null;
    this.activeFeatureInputs.set(inputs);
    this.activeFeature.set(feature);
  }

  public clearFeature() {
    this.activeFeature.set(null);
    this.activeFeatureInputs.set(undefined);
  }
}
